<div class="avatar-box">
  {{ label }}
  @if (!!data) {
    <img
      [src]="data"
      alt=""
      />
  }
</div>
